<template>
  <div class="mobile-personconfig-box">
    <div class="mobile-personconfig-content-wrap">
      <img src="@/assets/business/person_img.png" alt="" />
      <!-- 内容部分 -->
      <div class="mobile-personconfig-bottom">
        <div class="mobile-personconfig-left">
          <div class="mobile-en-title">{{ "config".toUpperCase() }}</div>
          <div class="mobile-cn-title">人力资源配置</div>
          <div
            class="mobile-personconfig-content-box"
            v-html="cleanHtmlText(data.content)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
